module.exports = __webpack_public_path__ + "img/absorbente12.9e48cdb0.jpg";